export default {
  successPage: {
    title: '资料提交成功',
    label: '环球支付审查团队会尽快完成资料审核，感谢您的申请。'
  }
}
